import { createFileRoute } from '@tanstack/react-router'

import { ACCOUNT } from '@brickup/shared/locales/de/account'
import { Account } from '@/components/Account/Account'
import { PageLayout } from '@/components/Internal/PageLayout'

export const Route = createFileRoute('/internal/account')({
  component: () => (
    <PageLayout
      title={ACCOUNT.accountSettings}
      contentClassName="overflow-y-auto"
    >
      <Account />
    </PageLayout>
  ),
})
